import { API_CONSTANT_MAP } from "./paths";
import requestApi from "./requestApi";

export const postLogin = (payload: string) => {
  return requestApi.postLogin(API_CONSTANT_MAP.login, payload);
};
